import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {ConnectedAccountsSelectionModalProps} from '@Modals/connected-accounts-selection-modal/connected-accounts-selection-modal.types';

export const isConnectedAccountsSelectionModalOpen = (): boolean => {
  return window.PMW.redux.store.getState().modals.modalsHashmap[MODALS_IDS.CONNECTED_ACCOUNTS_SELECTION_MODAL]?.isOpen;
};

export const openConnectedAccountsSelectionModal = (props: ConnectedAccountsSelectionModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.CONNECTED_ACCOUNTS_SELECTION_MODAL,
      isDismissible: false,
      panelProps: props,
    })
  );
};
